import React from "react";
import { Flex, Text } from "@appsmith/wds";

import { EmptyStateIllustrationCustomIcon } from "appsmith-icons";

export const ChatCitationEmpty = () => {
  return (
    <Flex
      alignItems="center"
      direction="column"
      gap="spacing-4"
      isInner
      padding="spacing-2"
      width="100%"
    >
      <EmptyStateIllustrationCustomIcon />
      <Text fontWeight={600} size="title" textAlign="center">
        Nothing here for now
      </Text>
      <Text
        color="neutral-subtle"
        fontWeight={500}
        style={{ textWrap: "balance" }}
        textAlign="center"
        wordBreak="break-word"
      >
        Referenced information will be shown here.
      </Text>
    </Flex>
  );
};
